module.exports = __webpack_public_path__ + "static/media/galerija_2021 (8)-min.d8b98a9f.jpg";